import { useLayoutEffect, useState } from 'react';
import { ThemeContext } from '../../constants/themes';
import Type from '../../components/atoms/Type';
import Button from '../../components/atoms/Button';
import Loader from '../../components/atoms/Loader';
import Navbar from '../../components/molecules/Navbar';
import Authenticator from '../../components/molecules/Authenticator';
import TextSubmit from '../../components/molecules/TextSubmit';
import { withAuth0 } from "@auth0/auth0-react";
import './index.css';
  
const PostSubscribe = (props) => {
  const [state, setState] = useState({

  });

  return (
    <ThemeContext.Consumer>
      {themeContext => (
        <div className="background" style={{backgroundColor: themeContext.theme.body}}>
          <Navbar promptDashboard promptSettings={false} authed={props.auth0.isAuthenticated} />
          <div className="dashboard-content-div">
            <Type type="h1">Cheers.</Type>
            <Type style={{margin: 0}}>You're all set to receive 1000 credits per month to request recordings of online content. Your account ({props.auth0.user?.email}) will be charged $10.00 per month.</Type>
            <br/>
            <Type style={{margin: 0}}>You can manage your subscription and cancel anytime in the "Account settings" page.</Type>
            <br/>
            <br/>
            <div>
              <Button value="Account settings" href="/settings" />
              <Button type="secondary" value="Back to dashboard" href="/dashboard" />
            </div>
          </div>
        </div>
      )}
    </ThemeContext.Consumer>
  );
}
  
export default withAuth0(PostSubscribe);
  